import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { styled } from 'styled-components';

export const StyledToastContainer = styled(ToastContainer).attrs({})`
    width: auto;
    margin: 1em;
    margin-top: 7em;
    padding: 2rem;

    .Toastify__toast {
        border: 1px solid ${({ theme }) => theme.colors.borderGray};
        padding: 1rem;
        min-height: 6rem;
        min-width: 20rem;
        border-radius: var(--radius);
        transition-duration: 100ms !important;
    }
`;
